import type { ComponentPropsWithoutRef } from 'react'
import { cn } from '@/lib/utils'

type SidebarPanelWrapperProps = Readonly<ComponentPropsWithoutRef<'div'>>

export default function SidebarPanelWrapper({
  children,
  className,
  ...props
}: SidebarPanelWrapperProps) {
  return (
    <div
      className={cn('flex h-full w-80 flex-col bg-background/60', className)}
      {...props}
    >
      {children}
    </div>
  )
}
